module.exports = __webpack_public_path__ + "static/media/chooseColor.6835fed4.svg";